import React, { useState } from 'react';
import './Header.css';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img src="/images/logo.png" alt="CreditHai" />
        </div>
        <button className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <a href="#products" className="nav-link">Products</a>
          <a href="#resource" className="nav-link">Resource</a>
          <a href="#support" className="nav-link">Support</a>
          
        </nav>
      </div>
    </header>
  );
}

export default Header;